<script>
  import { onMount, setContext } from "svelte";
  import { mapbox, key } from "./mapbox.js";

  setContext(key, {
    getMap: () => map
  });

  export let lat;
  export let lon;
  export let zoom;

  let container;
  let map;

  onMount(() => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "https://unpkg.com/mapbox-gl/dist/mapbox-gl.css";

    link.onload = () => {
      map = new mapbox.Map({
        container,
        style: "mapbox://styles/emmettmccann/ck8z41m4f014n1inw6emiz6hk",
        center: [lon, lat],
        zoom,
        attributionControl: false
      });
      map.getCanvas().style.cursor = "crosshair";
    };

    document.head.appendChild(link);

    return () => {
      map.remove();
      link.parentNode.removeChild(link);
    };
  });
</script>

<style>
  div {
    width: 100vw;
    height: 100vh;
    /* cursor: crosshair; */
  }
</style>

<div bind:this={container}>
  {#if map}
    <slot />
  {/if}
</div>
